/**
 * Degrade banner — the single most important thing a run detail view can
 * tell a user: this run was entitled to write code but had no brokered
 * credential, so it fell back to bot identity and read-only output. That
 * is exactly the case where a user expects an MR and gets none, so the
 * backend's own explanation (`degraded_reason`) is rendered verbatim and
 * prominently, never paraphrased.
 *
 * A run with `identity_mode: "bot"` and no degrade reason is a normal,
 * intentional read-only run — not an error — so this renders nothing for
 * it. Only a non-null `degraded_reason` triggers the banner.
 */

import type { ReactElement } from 'react';

interface DegradeBannerProps {
  reason: string | null;
}

export function DegradeBanner({ reason }: DegradeBannerProps): ReactElement | null {
  if (reason == null) return null;

  return (
    <div className="run-degrade-banner" role="alert">
      <strong className="run-degrade-banner__title">
        This run could not write code
      </strong>
      <p className="run-degrade-banner__reason">{reason}</p>
    </div>
  );
}
